export { Icon, getIconComponent, type IconProps } from './icon';
export { icons, type IconName, type SvgIconComponent } from './registry';
